import { render } from "./BaseInlineStatus.vue?vue&type=template&id=360afa45&scoped=true"
import script from "./BaseInlineStatus.vue?vue&type=script&lang=js"
export * from "./BaseInlineStatus.vue?vue&type=script&lang=js"

import "./BaseInlineStatus.vue?vue&type=style&index=0&id=360afa45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360afa45"]])

export default __exports__